export const ADD_SQUARE     = 'ADD_SQUARE';
export const REMOVE_SQUARE  = 'REMOVE_SQUARE';
export const SELECT_SQUARE  = 'SELECT_SQUARE';
export const TOGGLE_DEATH   = 'TOGGLE_DEATH';
export const SET_SQUARES    = 'SET_SQUARES';

export const ADD_SET        = 'ADD_SET';
export const ADD_MISTAKE    = 'ADD_MISTAKE';
export const ADD_POINTS     = 'ADD_POINTS';

export const SELECT_TOOL    = 'SELECT_TOOL';
export const ADD_TOOL       = 'ADD_TOOL';

export const TARGET_SQUARE  = 'TARGET_SQUARE';
export const DESELECT_TOOLS = 'DESELECT_TOOLS';
export const ALTER_SQUARE   = 'ALTER_SQUARE';
export const REPLACE_SQUARE = 'REPLACE_SQUARE';

export const ADD_STAR       = 'ADD_STAR';
export const POP_STAR       = 'POP_STAR';
export const COMBINE_STARS  = 'COMBINE_STARS';
export const SCORE_STARS    = 'SCORE_STARS';

export const SET_LEVEL      = 'SET_LEVEL';
export const SET_LEVEL_ID   = 'SET_LEVEL_ID';
export const SET_MOVES      = 'SET_MOVES';
export const SET_FAILED     = 'SET_FAILED';
export const SET_PALETTE    = 'SET_PALETTE';

export const ADD_GOAL       = 'ADD_GOAL';
export const REMOVE_GOAL    = 'REMOVE_GOAL';



// WEBPACK FOOTER //
// ./src/actions/types.js